import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("voucher/index"),
  
  store: (userData) => clientAuth.post('voucher/store', { json: userData }),
  
  

  show:(id)=>clientAuth.get('voucher/show/'+id),

  update:(id,userData)=>clientAuth.post(`voucher/update/${id}`,{json:userData}),

  destroy:(id)=>clientAuth.delete(`voucher/destroy/${id}`),
  Voucherlisting:() => clientAuth.get("Vouchercheckout/index"),
  updateStatus: (userData) => clientAuth.post('Vouchercheckout/updatestatus', { json: userData }),
  updatepaidstatus: (userData) => clientAuth.post('Vouchercheckout/updatepaidstatus', { json: userData }),
  updatecheckstatus: (userData) => clientAuth.post('Vouchercheckout/updatecheckstatus', { json: userData }),
  Voucherdestroy:(id)=>clientAuth.delete(`Vouchercheckout/destroy/${id}`),
  updateVoucherstatus: (id) => clientAuth.post(`notification/voucher/update/${id}`),

  
};